class LineItem {
    constructor(dataName, description, price, soRate = 0) {
        this.dataName = dataName
        const desc = description.replace(/[.:]/g, '');
        this.description = `${desc}`
        this.element = this.createElement()
        this.setPrice(price, soRate)
    }

    createElement() {
        const lineItemTemplate = document.querySelector('.booking-summary__line-items--item').cloneNode(true)
        lineItemTemplate.setAttribute('data-item-name', this.dataName)
        lineItemTemplate.setAttribute('data-item-order', this.setOrder(this.dataName))
        lineItemTemplate.querySelector('.booking-summary__description').innerText = this.description

        if (['discounted', 'special-offer'].includes(this.dataName)) {
            lineItemTemplate.classList.add('rent-modifier')
        }

        return lineItemTemplate
    }

    setPrice(price, soRate) {
        this.price = price
        const amount = this.element.querySelector('.booking-summary__amount')
        if (price < 0) {
            amount.classList.add('minus')
        }
        if (soRate) {
            this.element.setAttribute('data-item-so-rate', soRate)
        }        
        amount.setAttribute('data-amount', this.roundToTwoDecimalPlaces(price))
        amount.innerText = this.roundToTwoDecimalPlaces(Math.abs(price))     
    }

    remove() {
        const el = document.querySelector(`[data-item-name="${this.dataName}"]`)
        if (el) {
            el.remove()
        }
    }
    //this is also defined in Booking
    setOrder(dataName) {
        const orderMap = {
            'rental-price': 0,
            'discounted': 1,
            'special-offer': 2,
            'cancel-anytime': 3,
            'pet-fee': 4,
            'booking-fee': 5,
            'total': 99
        }
        return orderMap[dataName] ?? 98
    }
    roundToTwoDecimalPlaces(price) {
        price = parseFloat(price);
        return price.toFixed(2);
    }
}

export default LineItem
